import styled from 'styled-components';
import React, { ReactNode, FC, useState, useRef } from 'react';

interface Props {
  text: ReactNode;
  children: ReactNode;
  delay?: number;
  placement: 'bottom' | 'left';
}

const Tooltip: FC<Props> = ({ children, text, delay, placement }) => {
  const timeout = useRef<NodeJS.Timeout>();
  const [active, setActive] = useState<boolean>(false);

  const showTip = (): void => {
    timeout.current = setTimeout(() => {
      setActive(true);
    }, delay || 400);
  };

  const hideTip = (): void => {
    clearInterval(timeout.current);
    setActive(false);
  };

  return (
    <Container
      className='Tooltip-Wrapper'
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
      placement={placement}
    >
      {children}
      {active && <div className={`Tooltip-Tip ${placement}`}>{text}</div>}
    </Container>
  );
};

const Container = styled.div<{ placement: 'bottom' | 'left' }>`
  display: inline-block;
  position: relative;
  margin-left: 8px;

  > .Tooltip-Tip {
    position: absolute;
    border-radius: 10px;
    color: #fffaef;
    font-size: 1rem;
    font-family: "Poppins", sans-serif;
    z-index: 100;
  }

  /* Affichage Bottom */
  .Tooltip-Tip.bottom {
    transform: translate(-412px, 4px);
    max-width: 800px;
    min-width: 400px;
    height: auto;

    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 20px;

    background-color: #0b3d55;
    border: 1px solid #0b3d55;
    box-shadow: 2px 2px 10px rgba(4, 32, 46, 0.5);
  }

  /* Affichage Left */
  .Tooltip-Tip.left {
    transform: translate(-325px, -35px);
    min-width: 300px;
    max-width: 600px;
    height: auto;

    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 6px;

    background-color: #157a9e;
    border: 1px solid #157a9e;
    box-shadow: 2px 2px 10px rgba(4, 32, 46, 0.5);
  }
`;

export default Tooltip;
